unit Essentials.Web.Editors.Form;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, Essentials.Web.Attributes.Editor,
  Essentials.Web.Lookup.Editor, Essentials.Web.CustomNames.Editor, Essentials.Web.RequiredFields.Editor;

type
  TEssentialsManagersForm = class(TCoreWebForm)
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
    FAttributesForm: TEssentialsAttributeEditor;
    FLookupsForm: TEssentialsLookupEditor;
    FCustomNamesForm: TEssentialsCustomNameEditor;
    FRequiredFieldsForm: TEssentialsRequiredFieldEditor;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EssentialsManagersForm: TEssentialsManagersForm;

implementation

{$R *.dfm}

procedure TEssentialsManagersForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  Application.CreateForm(TEssentialsAttributeEditor, 'essentials.attributes.container', FAttributesForm);
  Application.CreateForm(TEssentialsLookupEditor, 'essentials.lookups.container', FLookupsForm);
  Application.CreateForm(TEssentialsCustomNameEditor, 'essentials.customnames.container', FCustomNamesForm);
  Application.CreateForm(TEssentialsRequiredFieldEditor, 'essentials.requiredfields.container', FRequiredFieldsForm);
end;

procedure TEssentialsManagersForm.LoadDFMValues;
begin
  inherited LoadDFMValues;


  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
  finally
  end;
end;

end.
